import React from "react";
import { withRouter } from "react-router-dom";

import "../styles/Sunset.css";

import sunsetImage from "../images/sunset.jpg";

const Sunset = () => {
    return (
        <div className="sunset-container">
            <img
                className="sunset-img"
                src={sunsetImage}
                alt="sunset background"
            />
            <div className="sunset-text-container">
                <div className="sunset-heading">PROFESSOR &nbsp; JONES</div>
                <div className="sunset-subheading">& THE RENDEZVOODOO</div>
            </div>
        </div>
    );
};

export default withRouter(Sunset);



// WEBPACK FOOTER //
// ./src/components/Sunset.js